import Slider from 'react-slick';
import classNames from 'classnames';

import SenseShape from '@assets/images/home/sense-shape.svg';
import GalleryShape from '@assets/images/home/gallery-curator-shape.svg';
import MultisensoryShape from '@assets/images/home/multisensory-shape.svg';

import './slider.css';
import styles from './style.module.scss';

const DATA = [
  {
    title: 'Aggiungere emozioni sensoriali all’opera d’arte',
    description: 'Audio, Aroma, luce e vibrazione.Le nostre tecnologie possono arricchire l`esperienza. ',
    image: SenseShape,
  },
  {
    title: 'Un ponte tra Arte Fisico e Digitale',
    description: 'Arricchisci i tuoi eventi culturali, esplora la bellezza  e la storia degli artisti, entra in contatto con Musei, Curatori, Gallerie e Collezionisti in un unico hub collaborativo, sia online che nella vita reale.',
    image: GalleryShape,
  },
  {
    title: 'Iscriviti al Portale',
    description: 'Che siate importanti galleristi, collezionisti esperti, o semplici appassionati, unitevi al nostro ecosistema per essere sempre aggiornati sulle opere inserite e sulle iniziative che verranno avviate ',
    image: MultisensoryShape,
  },
];

const sliderSettings = {
  dots: true,
  speed: 500,
  arrows: false,
  autoplay: true,
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  swipeToSlide: true,
  customPaging: () => <li />,
};

const DescriptionCarousel = () => (
  <div className={styles.root}>
    <div className={styles.root__wrapper}>
      {DATA.map(({
        image,
        title,
        description,
      }, index) => (
        <div key={index} className={styles.root__item}>
          <img src={image} alt="shape" className={styles.root__image} />
          <h1 className={styles.root__title}>{title}</h1>
          <p className={styles.root__description}>{description}</p>
        </div>
      ))}
    </div>
    <div className={classNames(styles.root__slider, 'description-slider-root')}>
      <Slider {...sliderSettings}>
        {DATA.map(({
          image,
          title,
          description,
        }, index) => (
          <div key={index} className={styles.root__item}>
            <img src={image} alt="shape" className={styles.root__image} />
            <h1 className={styles.root__title}>{title}</h1>
            <p className={styles.root__description}>{description}</p>
          </div>
        ))}
      </Slider>
    </div>
  </div>
);

export default DescriptionCarousel;
